angular.module('app').run(function (ngCheckScheduledPollsServant, DefaultRoute, ngPollPlatformServant) {
  ngCheckScheduledPollsServant.route = 'poll';
  ngCheckScheduledPollsServant.defaultRoute = DefaultRoute;

  ngPollPlatformServant.environment = 'desktop';
});
